import { CommonModule, DatePipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { OpportunityService } from '../features/opportunities/services/opportunity.service';
import { LostUserSvgComponent } from './components/landing-page/images/lost-user-svg.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { NotAuthorizedSvgComponent } from './components/not-authorized/images/not-authorized-svg.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import {
  AvailabilityDatePipe,
  AvailabilityTimePipe,
} from './pipes/availability-date.pipe';
import { FileStoreService } from './services/filestore.service';
import { NotificationService } from './services/notification.service';
import { TimezonePreferenceService } from './services/timezone-preference.service';
import { getLocale } from './utils/timezone.utils';

@NgModule({
  declarations: [
    AvailabilityDatePipe,
    AvailabilityTimePipe,
    NotAuthorizedComponent,
    NotAuthorizedSvgComponent,
    LandingPageComponent,
    LostUserSvgComponent,
  ],
  exports: [
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTooltipModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatMenuModule,
    RouterModule,
    MatTabsModule,
    AvailabilityDatePipe,
    AvailabilityTimePipe,
    NotAuthorizedSvgComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    MatTabsModule,
  ],
  providers: [
    OpportunityService,
    FileStoreService,
    NotificationService,
    DatePipe,
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
    },
    TimezonePreferenceService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
